(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lb-product-demo"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.lb-demo-frame video').forEach(video => {
      let visible = false;
      const play = () => { if (visible && !document.hidden) video.play().catch(() => {}); };
      new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; if (visible) play(); else video.pause(); }, {threshold: .2}).observe(video);
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else play(); });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lb-product-layout"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ref-everyday').forEach(section => {
  const track = section.querySelector('.ref-story-cards');
  if (!track) return;
  section.querySelectorAll('[data-story-direction]').forEach(button => {
    button.addEventListener('click', () => {
      const card = track.querySelector('article');
      const distance = card ? card.getBoundingClientRect().width + 24 : track.clientWidth;
      track.scrollBy({ left: Number(button.dataset.storyDirection) * distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
